import { render, staticRenderFns } from "./Notification.vue?vue&type=template&id=6a3e8b93&"
import script from "./Notification.vue?vue&type=script&lang=js&"
export * from "./Notification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/test-tripanels/clusterpanels/hwy-staff-panel/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6a3e8b93')) {
      api.createRecord('6a3e8b93', component.options)
    } else {
      api.reload('6a3e8b93', component.options)
    }
    module.hot.accept("./Notification.vue?vue&type=template&id=6a3e8b93&", function () {
      api.rerender('6a3e8b93', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/material/Notification.vue"
export default component.exports